import { cn } from '@seen/ui'
import type { JSX, MouseEventHandler, ReactNode, Ref } from 'react'

export function ObservationWrapper({
  children,
  onClick,
  className,
  noHover,
  ref,
}: {
  children: ReactNode
  onClick?: MouseEventHandler<HTMLSpanElement>
  className?: string
  noHover?: boolean
  ref?: Ref<HTMLSpanElement>
}): JSX.Element {
  return (
    <span
      onClick={onClick}
      className={cn(
        'flex select-none flex-wrap gap-y-0.5 rounded-sm border-[0.5px] border-gray-450 bg-gray-470 box-decoration-clone px-1 py-px hover:bg-gray-460 group-[.ProseMirror-selectednode]:bg-[lch(53_52.26_286.91/0.4)]',
        noHover && 'hover:bg-gray-470',
        className
      )}
      ref={ref}
    >
      {children}
    </span>
  )
}

export function ObservationNoValue({ label }: { label: string }): JSX.Element {
  return (
    <ObservationWrapper noHover>
      <span>{label}:&nbsp;</span>
      <span className="text-foreground-secondary">no value</span>
    </ObservationWrapper>
  )
}
